import type { ValidationRuleset } from 'lib/validation'
import { notEmptyValidator, emailValidator } from 'lib/validation'
export const formDefaults = {
  firstName: '',
  lastName: '',
  emailContact: '',
  budget: '',
  message: '',
  contactConfirm: false,
}

const numberValidator = (value: string): boolean => {
  const regex = /^[0-9]*$/
  return !!regex.test(value) && value !== ''
}

export const formValidationRules: ValidationRuleset = {
  emailContact: [
    {
      // ...notEmptyValidator,
      ...emailValidator,
      message: () => 'Email must be in correct format.',
    },
  ],
  firstName: [{ ...notEmptyValidator, message: () => 'Please enter a first name.' }],
  lastName: [],
  budget: [
    {
      validate: numberValidator,
      message: () => 'Must provide numeric values.',
    },
  ],
  message: [],
}